<template>
  <div class="m-broadcast">
    <h3>广播数据</h3>
    <p class="infos">
      您可以在此页面输入签过名的源数据，十六进制格式文本，并将其广播到比特元网络。
    </p>
    <textarea name class="textvalue" v-model="param"></textarea>
    <div class="tip">
      <i class="iconfont iconjinggao"></i>
      <p>
        <span>提示：建议在广播数据之前，去</span>
        <router-link to="/alytx">解析数据</router-link>
        <span>，检查您的数据文本</span>
      </p>
    </div>
    <p class="link" v-if="result">
      <router-link :to="{ path: '/tradeHash', query: { hash: result } }">{{
        result
      }}</router-link>
    </p>
    <div
      class="sub-btn flex-center"
      @click="submit(param, 'Ptx')"
      :class="{ disabled: isDisabled }"
    >
      发送数据
    </div>
  </div>
</template>

<script setup>
import ToolMixins from "@/mixins/tool";
import { ref } from "vue";

const param = ref();
const { result, isDisabled, submit } = ToolMixins();
</script>

<style lang="scss" scoped>
.m-broadcast {
  padding: 11px 20px 30px;
  h3 {
    font-size: 14px;
    font-family: PingFangSC-Semibold;
    color: #53657a;
  }
  .link {
    margin-top: 20px;
  }
  .infos {
    margin: 12px 0 20px;
    color: $font_grey;
    line-height: 20px;
  }
  .sub-btn {
    width: 160px;
    height: 40px;
    margin: 20px auto 0;
    background: $blue;
    border-radius: 25px;
    color: $white;
    font-size: 14px;
    cursor: pointer;
    transition: 0.3s;
  }
  .disabled {
    background: $grey_deep;
    cursor: not-allowed;
  }
  .tip {
    margin-top: 20px;
    color: $orange_deep;
    vertical-align: top;
    .iconjinggao {
      font-size: 18px;
      vertical-align: top;
    }
    p {
      display: inline-block;
      width: calc(100% - 40px);
      vertical-align: top;
      margin-left: 10px;
      font-size: 14px;
      font-family: PingFangSC-Semibold;
      a {
        color: $blue;
      }
    }
  }
  .textvalue {
    width: 100%;
    height: 200px;
    padding: 10px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 2px solid rgba(235, 239, 241, 1);
    resize: none;
    font-size: 14px;
  }
}
</style>